<template>
  <v-app>
    <div id="app">
      <NavHeader />
      <router-view></router-view>
    </div>
  </v-app>
</template>

<script>
import "normalize.css";
import NavHeader from "./components/NavHeader";

export default {
  components: { NavHeader },
  name: "app",
  data() {
    return {};
  },
  methods: {
    // goTop() {
    //   this.$router.push("/");
    // }
  },
};
</script>

<style lang="scss">
@import "./scss/style.scss";

html {
  touch-action: manipulation;
}
#app {
  font-family: "Lato", "Noto Sans JP", "ヒラギノ角ゴ ProN",
    "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, "ＭＳ Ｐゴシック",
    "MS PGothic", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
h1,
h2 {
  font-weight: normal;
  text-align: left;
  color: $theme-color;
}
h1 {
  font-size: 24px;
}
h2 {
  font-size: 20px;
  margin: 16px 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: $theme-color;
}
.v-application a {
  color: #fff;
}
.container {
  width: 100%;
  max-width: 640px;
  padding: 0 20px;
}
.btn {
  margin-top: 20px;
  width: 50%;
  height: 52px;
  line-height: 52px;
  font-size: 18px;
}
</style>
